import type { ApiUserEnvironment } from '#/api/userEnvironment/types/ApiUserEnvironment';
import type { NonNullableFields } from '#/types/NonNullableFields';
import { postJson } from '#/utils/http/postJson';

type Response = {
  userEnvironment: NonNullableFields<ApiUserEnvironment>;
};

export function userDashboardApiEnableProfileFeatures(): Promise<Response> {
  return postJson<Response>('/data/userdashboard/profile/enable');
}
